import { CaseReducer } from "@reduxjs/toolkit";
import { InitState } from "core/init/constants";

export const initializeReducer: CaseReducer<InitState> = (state) => {
    state.initialized = true;
};
